import React, { useEffect, createElement } from 'react';
export const GoogleTagManager = () => {
  useEffect(() => {
    // Create and inject GTM script
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5S633DJB');
    `;
    document.head.insertBefore(script, document.head.firstChild);
    // Create and inject noscript iframe
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-5S633DJB';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    // Insert after the opening body tag
    document.body.insertBefore(noscript, document.body.firstChild);
    // Cleanup function
    return () => {
      // If needed, cleanup could be implemented here
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything visible
};